export interface AffiliateResponse {
	partnerId: string;
	affcode: string;
	token: string;
	utmCookiesNames?: AffiliateUTMParams;
}

export interface AffiliateUTMParams {
	utm_source?: string;
	utm_medium?: string;
	utm_campaign?: string;
	utm_term?: string;
	utm_content?: string;
}

export const UTM_COOKIE_NAMES: AffiliateUTMParams = {
	utm_source: "utm_source",
	utm_medium: "utm_medium",
	utm_campaign: "utm_campaign",
	utm_term: "utm_term",
	utm_content: "utm_content",
};
